import { CommonModule } from '@angular/common';
import {
  Component,
  forwardRef,
  input,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { STORE_COUNTRY_OPTIONS } from '../constants/store-config.constants';

@Component({
  selector: 'app-country-select',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  styleUrl: './country-select.component.scss',
  template: `
    <select
      [id]="id()"
      [class]="selectClass()"
      [disabled]="disabled"
      [value]="value"
      (change)="onSelectChange($event)"
      (blur)="markTouched()"
    >
      <option value="" disabled>{{ placeholder() }}</option>
      @for (opt of options; track opt.value) {
        <option [value]="opt.value">{{ opt.label }}</option>
      }
    </select>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountrySelectComponent),
      multi: true,
    },
  ],
})
export class CountrySelectComponent implements ControlValueAccessor {
  readonly id = input<string>('');
  readonly placeholder = input<string>('Select a country…');
  /** Pass through existing page styling (e.g. `input` or `field-select`). */
  readonly selectClass = input<string>('input');

  readonly options = STORE_COUNTRY_OPTIONS;

  value = '';
  disabled = false;

  private onChange: (value: string) => void = () => undefined;
  private touched: () => void = () => undefined;

  writeValue(value: string | null): void {
    this.value = String(value ?? '');
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.touched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectChange(event: Event): void {
    const v = (event.target as HTMLSelectElement | null)?.value ?? '';
    this.value = v;
    this.onChange(v);
  }

  markTouched(): void {
    this.touched();
  }
}

